/**
 * Collider binding as a feature (M10 P1a2): binds the ship stream to the sim so every ship collides as the model it
 * shows (`assets/colliderBinding.ts`). `afterTick` runs after the career (its commits switch the flown hull inside a
 * tick); `frame` covers the Hangar switch, which commits while docked, when the hold runs no tick. Every mode with a
 * ship stream; allocation-free per tick and per frame.
 */
import { FEATURE_ORDER, type GameContext, type GameFeature } from '../../app/feature'
import { createColliderBinder, syncPlayerCollider, type ColliderBinder } from '../../assets/colliderBinding'
import { loadShipViewsConfig } from '../../render/shipViewsConfig'

/** Right after the career (150), so its in-tick commits are bound in the same tick. */
const ORDER = FEATURE_ORDER.career + 2

let binder: ColliderBinder | null = null

const feature: GameFeature = {
  name: 'shipBinding',
  order: ORDER,
  init(ctx: GameContext): void {
    const ships = ctx.services.maybe('ships')
    if (ships === undefined) return
    binder = createColliderBinder(ctx.sim, ships, { flownDef: loadShipViewsConfig().perHullView })
  },
  afterTick(): void {
    if (binder !== null) syncPlayerCollider(binder)
  },
  frame(): void {
    if (binder !== null) syncPlayerCollider(binder)
  },
  dispose(): void {
    binder?.dispose()
    binder = null
  },
}

export default feature
